import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import DropdownField from 'components/molecules/DropdownField';
import css from './AdvancedSettings.css';
import { sitePropType } from './propTypes';

const UserPrivacySection = ({ site, readOnly, onSitePatch }) => (
    <section className={css.formSection}>
        <h4>
            <Translate id="STATIC.PAGES.APPS_CONFIGURATION.USER_PRIVACY" />
        </h4>
        <DropdownField
            label="STATIC.PAGES.APPS_CONFIGURATION.LDS_DEFAULT"
            labelTooltip="STATIC.PAGES.APPS_CONFIGURATION.LDS_DEFAULT_TOOLTIP"
            selected={String(!!site.lds_default)}
            items={[
                {
                    name: 'false',
                    display_name: <Translate id="STATIC.PAGES.APPS_CONFIGURATION.LDS_FALSE_DEFAULT" />,
                },
                { name: 'true', display_name: <Translate id="STATIC.PAGES.APPS_CONFIGURATION.LDS_TRUE" /> },
            ]}
            disabled={readOnly}
            onChange={selectedValue => onSitePatch({ lds_default: selectedValue === 'true' })}
            containerClass={classNames(css.admonDropdownField, css.inlineDropdownField)}
        />
    </section>
);

UserPrivacySection.propTypes = {
    onSitePatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
};

export default UserPrivacySection;
